module.exports = __webpack_public_path__ + "static/media/evo-firmware-update-device.c680fa97.png";